module.exports = "/packs/images/svg/ireland/accessibility/ramp~967b569665dc60691b54bb25209baef8.svg";